import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import AssetsCredit from '../../../components/assets-credit/assets-credit';
import AppPageMain from '../../../modules/app-page/app-page--main';
import PageHeader from '../../../modules/page-header';
import { useAppDispatch } from '../../../store';
import { getCreditConstraints } from '../../../store/actions/operations-sign';
import { RootState } from '../../../types';

const CreditInitPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const constraints = useSelector(
    (state: RootState) => state.operationsSign.data.credit.constraints
  );
  const loadingConstraints = useSelector(
    (state: RootState) => state.operationsSign.loading.creditConstraints
  );

  useEffect(() => {
    dispatch(getCreditConstraints());
  }, []);

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                { link: '/assets', title: 'Активы' },
                { link: '#', title: 'Займы' },
              ]}
              iconType="assets"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <AssetsCredit
              constraints={constraints}
              loadingConstraints={loadingConstraints}
            />
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default CreditInitPage;
